import { render, staticRenderFns } from "./oeb-config.vue?vue&type=template&id=a3bf4c9a&scoped=true"
import script from "./oeb-config.vue?vue&type=script&lang=js"
export * from "./oeb-config.vue?vue&type=script&lang=js"
import style0 from "./oeb-config.vue?vue&type=style&index=0&id=a3bf4c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf4c9a",
  null
  
)

export default component.exports